import React from "react"

import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Application } from "@/contexts/ApplicationContext"

interface AddressDetailsSectionProps {
  application: Application
  setApplication: React.Dispatch<React.SetStateAction<Application>>
}

const AddressDetailsSection: React.FC<AddressDetailsSectionProps> = ({
  application,
  setApplication,
}) => {
  return (
    <div className="space-y-4">
      <h2 className="mb-4 text-xl font-bold">Address Details</h2>

      <div className="space-y-2">
        <Label htmlFor="addressLine1">Address Line 1</Label>
        <Input
          id="addressLine1"
          value={application.personalDetails.address.line1}
          onChange={(e) =>
            setApplication((prev) => ({
              ...prev,
              personalDetails: {
                ...prev.personalDetails,
                address: {
                  ...prev.personalDetails.address,
                  line1: e.target.value,
                },
              },
            }))
          }
          placeholder="Enter your street address"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="addressLine2">Address Line 2 (optional)</Label>
        <Input
          id="addressLine2"
          value={application.personalDetails.address.line2}
          onChange={(e) =>
            setApplication((prev) => ({
              ...prev,
              personalDetails: {
                ...prev.personalDetails,
                address: {
                  ...prev.personalDetails.address,
                  line2: e.target.value,
                },
              },
            }))
          }
          placeholder="Apartment, suite, unit, etc."
        />
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div className="space-y-2">
          <Label htmlFor="city">City</Label>
          <Input
            id="city"
            value={application.personalDetails.address.city}
            onChange={(e) =>
              setApplication((prev) => ({
                ...prev,
                personalDetails: {
                  ...prev.personalDetails,
                  address: {
                    ...prev.personalDetails.address,
                    city: e.target.value,
                  },
                },
              }))
            }
            placeholder="Enter your city"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="postcode">Postcode</Label>
          <Input
            id="postcode"
            value={application.personalDetails.address.postcode}
            onChange={(e) =>
              setApplication((prev) => ({
                ...prev,
                personalDetails: {
                  ...prev.personalDetails,
                  address: {
                    ...prev.personalDetails.address,
                    postcode: e.target.value,
                  },
                },
              }))
            }
            placeholder="Enter your postcode"
          />
        </div>
      </div>
    </div>
  )
}

export default AddressDetailsSection
